import { MRT_ColumnDef } from 'material-react-table';
import { TableCell } from '../../../components/table/TableCell';
import { CopyComponent } from '../../../components/CopyComponent';
import React from 'react';
import { ColumnSizing } from '../tables-context';
import { RELATED_ENTITY_TYPE, RelatedEntityNameLink } from '../../../components/merchants/RelatedEntityNameLink';

export enum AccountMerchantTableAccessorKey {
	id = 'id',
	merchantName = 'companyName',
	dba = 'dba',
	// partnerName = 'partnerName',
	// contactName = 'contactName',
	// email = 'email',
	// status = 'status'
}

export const defaultAccountMerchantsColumnSizing: ColumnSizing = {
	[AccountMerchantTableAccessorKey.id]: 100,
	[AccountMerchantTableAccessorKey.merchantName]: 100,
	[AccountMerchantTableAccessorKey.dba]: 100,
};

export const defaultAccountMerchantsColumns: MRT_ColumnDef<any>[] = [
	{
		accessorKey: AccountMerchantTableAccessorKey.id,
		header: 'Id',
		enableSorting: false,
		Header: <span className="margin-left-0 text-muted fw-bolder main-font-family">Id</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => {
			// const path = `/merchants/merchants/${renderedCellValue}/${MERCHANTS_TABS.BUSINESS}`;
			return (
				<TableCell
					additionalClass="d-flex align-items-center main-font-family text-black fs-7"
					density={table?.options?.state?.density}
					isTextOverflow={true}
				>
					<CopyComponent value={renderedCellValue} title="Merchant Id"/>
					<div className="ms-2">{renderedCellValue}</div>
				</TableCell>
			);
		}
	},
	{
		accessorKey: AccountMerchantTableAccessorKey.merchantName,
		header: 'Merchant name',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Merchant name</span>,
		Cell: ({ renderedCellValue, row, table }: any): JSX.Element => (
			<TableCell
				additionalClass="d-flex align-items-center main-font-family text-black fs-7"
				density={table?.options?.state?.density}
				isTextOverflow={false}
			>
				<RelatedEntityNameLink name={renderedCellValue} id={row?.original?.id} type={RELATED_ENTITY_TYPE.MERCHANT}/>
			</ TableCell>
		)
	},
	{
		accessorKey: AccountMerchantTableAccessorKey.dba,
		header: 'Dba',
		enableSorting: false,
		Header: <span className="margin-left-0 text-muted fw-bolder main-font-family">Dba</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="d-flex align-items-center main-font-family text-black fs-7"
				density={table?.options?.state?.density}
				isTextOverflow={true}
			>
				{renderedCellValue}
			</TableCell>
		)
	},
];
